import Vue from 'vue'

import Vuex from 'vuex'
import {getShopInfo} from '../api/login'
import {removeToken} from '../utils/auth'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    shopInfo: {}
  },
  mutations: {
    setShopInfo (state, info) {
      state.shopInfo = info
    }
  },
  actions: {
    getShopInfo ({commit, state}) {
      return new Promise((resolve, reject) => {
        getShopInfo().then(res => {
          commit('setShopInfo', res.result)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出系统
    LogOut ({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('setShopInfo', {})
        removeToken()
        resolve()
      })
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js